webpackJsonp([12212409830779],{

/***/ 764:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Quickstart = __webpack_require__(9);
	
	var _Quickstart2 = _interopRequireDefault(_Quickstart);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Quickstart2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Step 2: Parse the Collection'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In this step we\u2019ll begin restoring functionality to our application.'
	    ),
	    _react2.default.createElement(_QuickstartBranch2.default, { branch: 'server.2' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Why is the application broken?'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Our application is broken because the API response from the mock API is different than the response from the real API.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The mock API server had a response for ',
	      _react2.default.createElement(
	        'code',
	        null,
	        '/tweets'
	      ),
	      ' that looked like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      [\n        {...tweet...},\n        {...tweet...}\n      ]\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'But the response from the real API looks like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      {\n        data: [\n          {...tweet...},\n          {...tweet...}\n        ],\n        meta: {\n          paginate: {\n            currentPage: 1,\n            nextPage: 2,\n            prevPage: null,\n            totalPages: 11,\n            totalCount: 51,\n            perPage: 5\n          }\n        }\n      }\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The reason for the change is a positive one, as we now have clear metadata that we can use for pagination, but it still breaks our application.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Not to worry though; Lore is designed to be able to adapt to these kinds of breaking API changes, it just needs a little help from you to understand how.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Parse the Collection Response'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'To fix the application, open ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'config/connections.js'
	      ),
	      '. Towards the bottom of the file you\'ll see a property named ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'collections'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'blockquote',
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'Collections in Lore are the abstraction tier responsible for communicating with API endpoints like ',
	        _react2.default.createElement(
	          'code',
	          null,
	          '/tweets'
	        ),
	        ' that return array of resources.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'You can learn more about ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'collections'
	        ),
	        ' ',
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/collections/' },
	          'here'
	        ),
	        '.'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Nested within that property is a commented out function called ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'parse()'
	      ),
	      ' that looks like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      {\n        apiRoot: \'http://localhost:1337\',\n        ...\n        collections: {\n          properties: {\n            // parse: function(response) {\n            //   return response;\n            // }\n          }\n        }\n      }\n      ' }),
	    _react2.default.createElement(
	      'blockquote',
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'Like the other config files, this method is commented out because it reflects the default behavior of the framework.'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'When the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        '/tweets'
	      ),
	      ' endpoint returns data, that data is passed to the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'parse()'
	      ),
	      ' method as the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'response'
	      ),
	      ' argument, and this method is expected to return an array of resources.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The default behavior is to return whatever data was provided, and when we were using our mock API, that wasn\'t a problem, because the original API response ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'was'
	      ),
	      ' an array of tweets.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'But now the array we want is embedded inside the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'data'
	      ),
	      ' property of the server response, so we need to override this function to have it return that part of the response.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'To do that, modify the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'parse()'
	      ),
	      ' method to look like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      ...\n        collections: {\n          properties: {\n            parse: function(response) {\n              return response.data;\n            }\n          }\n        }\n      ...\n      ' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Visual Check-in'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If you refresh the browser, you\'ll see the application is still broken, but now we have a different error in the console:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'sh', text: '\n      Invalid call to `getState(\'user.byId\')`. Missing required attribute \'id\'.\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'We\'ll fix this error in the next step.'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Code Changes'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Below is a list of files modified during this step.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'config/connections.js'
	    ),
	    _react2.default.createElement(
	      _CodeTabs2.default,
	      null,
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES5', text: '\n        export default {\n\n          default: {\n\n            apiRoot: \'http://localhost:1337\',\n\n            collections: {\n              properties: {\n                parse: function(response) {\n                  return response.data;\n                }\n              }\n            }\n\n          }\n\n        }\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES6', text: '\n        export default {\n\n          default: {\n\n            apiRoot: \'http://localhost:1337\',\n\n            collections: {\n              properties: {\n                parse: function(response) {\n                  return response.data;\n                }\n              }\n            }\n\n          }\n\n        }\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ESNext', text: '\n        export default {\n\n          default: {\n\n            apiRoot: \'http://localhost:1337\',\n\n            collections: {\n              properties: {\n                parse: function(response) {\n                  return response.data;\n                }\n              }\n            }\n\n          }\n\n        }\n        ' })
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Next Steps'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Next we\'re going to ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '../step-3/' },
	        'continue restoring functionality to the application'
	      ),
	      '.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-quickstart-server-step-2-js-42752cd7466f6c44bfe1.js